import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import {
    isStatsFilter,
    isPriceFilter,
    isDimensionFilter,
    isWhiteGloveFilter,
    isFreeShippingFilter,
    constructStatsRange,
} from '../SbSharedRefineMenu/sbSharedRefineMenuHelpers';
import { handleMinimumFractionDigits } from 'dibs-buyer-price/exports/FormattedPrice';
import { sbSharedRefineMenuMessages } from '../SbSharedRefineMenu/sbSharedRefineMenuMessages';

// components
import { FormattedNumber } from 'react-intl';
import CloseIcon from 'dibs-vg/dist/react/close';

// styles
import styles from './SbRespAppliedFiltersItem.scss';

const rangeSeparator = sbSharedRefineMenuMessages.to;

const whiteGloveFilterMaxValue = filterValue => filterValue && filterValue.displayName;

const minMaxToAppliedFilterValue = (min, max) =>
    [min, ' ', rangeSeparator, ' ', max].map((comp, index) => (
        <React.Fragment key={index}>{comp}</React.Fragment>
    ));

const whiteGloveFilterValue = ({ currency, filterValue }) => {
    const min = (
        <FormattedNumber value={0} style="currency" currency={currency} minimumFractionDigits={0} />
    );

    const max = (
        <FormattedNumber
            value={whiteGloveFilterMaxValue(filterValue)}
            style="currency"
            currency={currency}
            minimumFractionDigits={0}
        />
    );

    return minMaxToAppliedFilterValue(min, max);
};

export const SbRespAppliedFiltersItem = props => {
    const {
        localizedFilterName,
        filterName,
        filterValue,
        onCloseClick,
        currency,
        availableValues,
        measurementUnit,
    } = props;
    const displayName = get(filterValue, 'displayName', null);
    const urlLabel = get(filterValue, 'urlLabel', null);
    let localizedFilterValue = localizedFilterName;
    let value = displayName;
    let dimension = null;

    if (isDimensionFilter(filterName)) {
        dimension = measurementUnit.toLowerCase();
    }

    if (isWhiteGloveFilter(filterName)) {
        value = whiteGloveFilterValue({ currency, filterValue });
    } else if (isStatsFilter(filterName)) {
        const [min, max] = constructStatsRange(urlLabel, get(availableValues, '[0].urlLabel')).map(
            rangeValue => {
                if (isPriceFilter(filterName)) {
                    return (
                        <FormattedNumber
                            value={rangeValue}
                            style="currency"
                            currency={currency}
                            minimumFractionDigits={handleMinimumFractionDigits(rangeValue)}
                        />
                    );
                } else {
                    return rangeValue;
                }
            }
        );

        value = minMaxToAppliedFilterValue(min, max);
    }

    if (isFreeShippingFilter(filterName)) {
        localizedFilterValue = sbSharedRefineMenuMessages.shippingOptions;
        value = sbSharedRefineMenuMessages.shippingFree;
    }

    return (
        <div className={styles.container} data-tn={`filter-${filterName}`}>
            <div>
                <span data-tn={`label-${filterName}`}>{localizedFilterValue}</span>
                {!!value && (
                    <React.Fragment>
                        <span>:</span>
                        <span className={styles.value} data-tn={`value-${filterName}`}>
                            {value}
                            {dimension || ''}
                        </span>
                    </React.Fragment>
                )}
            </div>
            <span
                data-tn="remove-filter"
                className={styles.closeIconWrapper}
                onClick={onCloseClick}
            >
                <CloseIcon />
            </span>
        </div>
    );
};

SbRespAppliedFiltersItem.propTypes = {
    currency: PropTypes.string,
    filterName: PropTypes.string.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    filterValue: PropTypes.object,
    availableValues: PropTypes.array.isRequired,
    measurementUnit: PropTypes.string,
    localizedFilterName: PropTypes.string,
};
